module.exports = __webpack_public_path__ + "static/img/invoice2.e51a8a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invoice2.jpg
// module id = Q7Wo
// module chunks = 3